const Mail = () => {
  return (
    <div className="mail fixed left-10 bottom-28">
      <a
        href="mailto:applotnwjd@naver.com"
        className="hidden text-vertical text-zinc-400 pt-mono transition-all hover:-translate-y-1 hover:text-blue-400 hover:text-bold lg:block"
      >
        applotnwjd@naver.com
      </a>
      <div className="hidden w-[1px] h-24 bg-zinc-400 fixed left-12 bottom-0 lg:block"></div>
    </div>
  );
};

export default Mail;
